import { ThemePalette } from '@angular/material/core';

export class FAB {
    constructor(
        public color: ThemePalette,
        public icon: string,
        public items: Array<Object>
    ) { }
}
